import type { AppRouteModule } from '/@/router/types';

import { t } from '/@/hooks/web/useI18n';
import { LAYOUT } from '/@/router/constant';

/**
 * 'bidding-manage': '招标管理',
 */
const route: AppRouteModule = {
  path: '/bidding-manage',
  name: 'BiddingManage',
  component: LAYOUT,
  redirect: '/bidding-manage/bid-apply',
  meta: {
    icon: 'ic:sharp-my-location',
    title: t('routes.bidding-manage.main'),
    orderNo: 10000,
    roles: [20222061],
  },
  children: [
    /**
     * 'bidding-registration': '招标计划',
     */
    {
      path: 'bidding-registration',
      name: 'BiddingRegistration',
      component: () => import('/@/views/bidding-manage/bidding-registration/index.vue'),
      meta: {
        title: t('routes.bidding-manage.bidding-registration'),
        hideChildrenInMenu: true,
        dynamicLevel: 1,
        roles: [20222062],
      },
      children: [
        /**
         * 'tender-details': '招标详情',
         */
        {
          path: 'tender-details',
          name: 'TenderDetails',
          component: () => import('/@/views/bidding-manage/tender-details/index.vue'),
          meta: {
            title: t('routes.bidding-manage.tender-details'),
            hideTab: true,
          },
        },
      ],
    },

    // /**
    //  * 'bid-apply': '招标报名',
    //  */
    // {
    //   path: 'bid-apply',
    //   name: 'BiddingManageBidApply',
    //   component: () => import('/@/views/bidding-manage/bid-apply/index.vue'),
    //   meta: {
    //     title: t('routes.bidding-manage.bid-apply'),
    //     roles: [20222063],
    //   },
    // },
    // /**
    //  * 'supplier-upload': '供应商文件上传',
    //  */
    // {
    //   path: 'supplier-upload',
    //   name: 'BiddingManageSupplierUpload',
    //   component: () => import('/@/views/bidding-manage/supplier-upload/index.vue'),
    //   meta: {
    //     title: t('routes.bidding-manage.supplier-upload'),
    //     roles: [20222064],
    //   },
    // },
    // /**
    //  * 'supplier-quote': '供应商报价',
    //  */
    // {
    //   path: 'supplier-quote',
    //   name: 'BiddingManageSupplierQuote',
    //   component: () => import('/@/views/bidding-manage/supplier-quote/index.vue'),
    //   meta: {
    //     title: t('routes.bidding-manage.supplier-quote'),
    //     roles: [20222065],
    //   },
    // },
    // /**
    //  * 'bid-question-counsel': '招标问题咨询',
    //  */
    // {
    //   path: 'bid-question-counsel',
    //   name: 'BidQuestionCounsel',
    //   component: () => import('/@/views/bidding-manage/bid-question-counsel/index.vue'),
    //   meta: {
    //     title: t('routes.bidding-manage.bid-question-counsel'),
    //     roles: [20222066],
    //   },
    // },
    /**
     * 'quotation-management': '报价管理',
     */
    {
      path: 'quotation-list',
      name: 'QuotationList',
      component: () => import('/@/views/bidding-manage/quotation-list/index.vue'),
      meta: {
        title: t('routes.bidding-manage.quotation-management'),
        roles: [20222067],
      },
    },
    /**
     * 'quotation-management': '报价详情',
     */
    {
      path: 'quotation-detail',
      name: 'QuotationDetail',
      component: () => import('/@/views/bidding-manage/quotation-detail/index.vue'),
      meta: {
        title: t('routes.bidding-manage.quotation-detail'),
        hideTab: true,
        hideMenu: true,
        ignoreKeepAlive: true,
        currentActiveMenu: '/bidding-manage/quotation-list',
      },
    },
    /**
     * 'quotation-filling': '报价填报',
     */
    {
      path: 'quotation-filling',
      name: 'QuotationFilling',
      component: () => import('/@/views/bidding-manage/quotation-filling/index.vue'),
      meta: {
        title: t('routes.bidding-manage.quotation-filling'),
        hideTab: true,
        hideMenu: true,
        ignoreKeepAlive: true,
        currentActiveMenu: '/bidding-manage/quotation-list',
      },
    },
    /**
     * 'price-correction-feedback': '价格纠错反馈',
     */
    {
      path: 'price-correction-feedback',
      name: 'PriceCorrectionFeedback',
      component: () => import('/@/views/bidding-manage/price-correction-feedback/index.vue'),
      meta: {
        title: t('routes.bidding-manage.price-correction-feedback'),
        roles: [20222370],
      },
    },
    /**
     * my-bid: '我的中标',
     */
    {
      path: 'my-bid',
      name: 'MyBid',
      component: () => import('/@/views/bidding-manage/my-bid/index.vue'),
      meta: {
        title: t('routes.bidding-manage.my-bid'),
        roles: [20222395],
      },
    },
    /**
     * 'quotation-management': '报价详情',
     */
    {
      path: 'quotation-details',
      name: 'QuotationDetails',
      component: () => import('/@/views/bidding-manage/quotation-details/index.vue'),
      meta: {
        title: t('routes.bidding-manage.quotation-details'),
        hideTab: true,
        hideMenu: true,
        ignoreKeepAlive: true,
        currentActiveMenu: '/bidding-manage/my-bid',
      },
    },
    /**
     * bidding-satisfaction-survey: '招标满意度调查',
     */
    {
      path: 'bidding-satisfaction-survey',
      name: 'BiddingSatisfactionSurvey',
      component: () => import('/@/views/bidding-manage/bidding-satisfaction-survey/index.vue'),
      meta: {
        title: t('routes.bidding-manage.bidding-satisfaction-survey'),
        roles: [20225851],
      },
    },
  ],
};

export default route;
